import { CheckoutLayout } from "@/components/checkout/checkout-layout";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export function CreditCheckDeniedPage() {
  const { t } = useTranslation();

  return (
    <CheckoutLayout>
      <Card className="text-center p-8">
        <h1 className="font-bold text-3xl mb-5">{t("denied.title")}</h1>
        <p className="mb-5 text-black/60">{t("denied.body")}</p>

        <div>
          <h2 className="font-semibold text-lg mb-5">
            {t("denied.whatCanYouDo")}
          </h2>

          <div className="border rounded-8 text-left p-5">
            <h2 className="font-semibold text-lg mb-1">{t("denied.buyTitle")}</h2>
            <p className="mb-4 text-sm text-black/60">{t("denied.buyBody")}</p>
            <Button
              className="flex justify-center items-center w-full"
              variant={"secondary"}
              size={"lg"}
              onClick={() => {
                window.location.href = "https://refurbly.se";
              }}
            >
              {t("denied.buyCta")} <ArrowRight />
            </Button>
          </div>
        </div>
      </Card>
      <Card className="text-center p-8">
        <h2 className="text-lg mb-1 font-light">
          <span className="font-semibold">{t("denied.needHelp")}</span>{" "}
          {t("denied.contactSupport")}{" "}
          <a href="mailto:support@refurbly.se">support@refurbly.se</a>
        </h2>
      </Card>
    </CheckoutLayout>
  );
}
